export default "__VITE_ASSET__e9b258b2__"